import {ref} from 'vue'
import type { UserCommonInfoDto, } from "~/types/mypage/backend-dto-types";
import type { RecentsearchwordsDto } from "~/types/display/backend-dto-types";
const bsktCnt = ref(0)
const tmpOrdCnt = ref(0)
const recentSearchwordsInfo = ref<RecentsearchwordsDto[]>();
const commonInfo = ref<UserCommonInfoDto>();
// 전역 팝업 설정
const { showAlert } = usePopup()
interface RecentProduct  {
  index: number;
  text: string,
  link: string;
  image: string; 
}
const recentProducts = ref<RecentProduct[]>([])

const refreshRecentProductList = () => {
  recentProducts.value = [];
  const sessionlist = sessionStorage.getItem('product.recentViewList');
  const rcntProductList: RecentProduct[] = sessionlist ? JSON.parse(sessionlist) : [];
  recentProducts.value = rcntProductList.sort((a,b) => b.index - a.index)
                                        .map((item, index) => ({
                                            ...item,
                                            index
                                          }));
  sessionStorage.setItem("product.recentViewList", JSON.stringify(recentProducts.value))
}

const refreshCnt = async () => {
  const userKey = useHconAuthInfo().getIfPossible()?.userContext.userKey;
  if(userKey != '' && userKey != undefined) {
    await $fetch.raw<AjaxResult<UserCommonInfoDto>>('/api/v1/mypage/common/userCommonInfo', {
      baseURL: useHconConfig().api.baseUrl,
      method: 'GET',
      //credentials: 'include',
      query: {
        userKey:userKey
    }
    }).then(result => {
      if (result._data?.resultCode != "200") {
        showAlert(result._data?.resultMessage??'')
      } else {
        commonInfo.value = result._data?.data;
        if(result._data?.data.userProductDto){
          bsktCnt.value = result._data?.data.userProductDto.bsktCnt??0
          tmpOrdCnt.value =  result._data?.data.userProductDto.tmpOrdCnt??0
        } else {
          bsktCnt.value = 0
          tmpOrdCnt.value = 0
        }
      }
    })
}
}
 
// 최근검색어 목록 조회 API 호출
const refreshRecentSearchwords = async () => {
  const userKey = useHconAuthInfo().getIfPossible()?.userContext.userKey;
  
  if(userKey != '' && userKey != undefined) {
    await $fetch.raw<AjaxResult<RecentsearchwordsDto[]>>('/api/v1/product/display/recent-searchwords/list',{
      baseURL: useHconConfig().api.baseUrl,
      method: 'GET',
      query: {
        userKey:userKey
    }
    }).then(result => {
      if (result._data?.resultCode != "200") {
        showAlert(result._data?.resultMessage??'')
      } else {
        recentSearchwordsInfo.value = [];
        recentSearchwordsInfo.value = result._data?.data
      }
    }).catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200') {
        showAlert(error.resultMessage)
      }
    })
  }
}

export const useHeader = () => {
    return {
        bsktCnt,
        tmpOrdCnt,
        recentSearchwordsInfo,
        commonInfo,
        refreshRecentSearchwords,
        refreshRecentProductList,
        recentProducts,
        setBsktCnt : (v: number) => bsktCnt.value = v,
        setTmpOrdCnt : (v: number) => tmpOrdCnt.value = v,
        refreshCnt
    }
}